export function NewsSlide() {
	this.element = null;
	this.nextNewsItem = "";
}
NewsSlide.prototype.elementCreated = function(element) {
	this.element = element;
};
NewsSlide.prototype.prepare = function() {
	var self = this;
	var xhr = new XMLHttpRequest();
	xhr.open('GET', '/api/news');
	xhr.onreadystatechange = function() {
		if (xhr.readyState === 4) {
			var response = JSON.parse(xhr.responseText);
			self.nextNewsItem = response.text;
		}
	};
	xhr.send(null);
};
NewsSlide.prototype.show = function() {
	var p = this.element.querySelector('p');
	while (p.childNodes.length) {
		p.removeChild(p.childNodes[0]);
	}
	var first = true;
	this.nextNewsItem.split("\n").forEach(function (newsline) {
		if (first) {
			first = false;
		}
		else {
			p.appendChild(document.createElement("br"));
		}
		p.appendChild(document.createTextNode(newsline));
	});
};
NewsSlide.prototype.hide = function() {
};
